import { render, staticRenderFns } from "./myTable.vue?vue&type=template&id=0f4c0575&scoped=true&"
import script from "./myTable.vue?vue&type=script&lang=js&"
export * from "./myTable.vue?vue&type=script&lang=js&"
import style0 from "./myTable.vue?vue&type=style&index=0&id=0f4c0575&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4c0575",
  null
  
)

export default component.exports